// src/features/tidsregistering/hooks/useSickLeaveTrackers.js
import { useState, useCallback } from 'react';
import { sickLeaveTrackersAPI } from '../services/sickLeaveTrackers';
import { useApi } from '../../../hooks/api/useApi';

export function useSickLeaveTrackers() {
  const [tracker, setTracker] = useState(null);
  const [trackers, setTrackers] = useState([]);
  const { loading, error, execute, clearError } = useApi();

  const fetchForDepartment = useCallback(async () => {
    const result = await execute(() => sickLeaveTrackersAPI.listForDepartment());
    if (result.success) setTrackers(result.data?.trackers ?? []);
    return result;
  }, [execute]);

  // Keep the department list in step with a single tracker the API returned,
  // so the overview table updates without refetching the page.
  const upsertTracker = useCallback((updated) => {
    if (!updated?.staff_member_id) return;
    setTrackers((prev) => {
      const rest = prev.filter((t) => t.staff_member_id !== updated.staff_member_id);
      return [...rest, updated];
    });
  }, []);

  const fetchTracker = useCallback(async (staffMemberId) => {
    const result = await execute(() => sickLeaveTrackersAPI.getTracker(staffMemberId));
    if (result.success) setTracker(result.data ?? null);
    return result;
  }, [execute]);

  const rebuildTracker = useCallback(async (data) => {
    const result = await execute(() => sickLeaveTrackersAPI.rebuildTracker(data));
    if (result.success) {
      setTracker(result.data ?? null);
      upsertTracker(result.data);
    }
    return result;
  }, [execute, upsertTracker]);

  const recordDoctorNote = useCallback(async (data) => {
    const result = await execute(() => sickLeaveTrackersAPI.recordDoctorNote(data));
    if (result.success) {
      setTracker(result.data ?? null);
      upsertTracker(result.data);
    }
    return result;
  }, [execute, upsertTracker]);

  return {
    tracker,
    trackers,
    loading,
    error,
    clearError,
    fetchForDepartment,
    fetchTracker,
    rebuildTracker,
    recordDoctorNote,
  };
}
